import axios from "axios";
import { logApiError } from "../services/activityLogService";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 10000,

});
//  Request interceptor 
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (config.url) {
      let url = config.url;
      if (url.startsWith('/user/') || url === '/user') {
        url = url.replace('/user', '/web-user');
      } else if (url.startsWith('/orders')) {
        url = url.replace('/orders', '/web-user/orders');
      } else if (url.startsWith('/cart')) {
        url = url.replace('/cart', '/web-user/cart');
      } else if (url.startsWith('/wallet')) {
        url = url.replace('/wallet', '/web-user/wallet');
      } else if (url.startsWith('/payment')) {
        url = url.replace('/payment', '/web-user/payment');
      } else if (url.startsWith('/auth')) {
        url = url.replace('/auth', '/web-user/auth');
      } else if (url.startsWith('/tickets')) {
        url = url.replace('/tickets', '/web-user/tickets');
      } else if (url.startsWith('/home')) {
        url = url.replace('/home', '/web-user/home');
      }
      config.url = url;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

//  Response interceptor 
api.interceptors.response.use(
  (response) => response,
  (error) => {
    //  Token expired / Unauthorized
    if (error.response?.status === 401) {
      localStorage.removeItem("token");

      // Only redirect to login if the user is NOT on a public page!
      const publicPaths = ['/home', '/search', '/restaurant', '/login', '/signup', '/register'];
      const currentPath = window.location.pathname;
      const isPublic = publicPaths.some(p => currentPath.startsWith(p)) || currentPath === '/';

      if (!isPublic) {
        window.location.href = "/login";
      }
    }

    //  Server error / network error logging
    if (error.response?.status >= 500 || !error.response) {
      logApiError(error);
    }

    return Promise.reject(error);
  }
);

export default api;